<template>
	<main v-loading.fullscreen.lock="isLoading" element-loading-background="rgba(180, 200, 240, 0.3)">
		<div class="bg-image"></div>
		<el-container v-if="!isAuthenticating">
			<el-main>
				<login-form v-if="!isAuthenticated" />
				<info-kelulusan v-else />
			</el-main>
		</el-container>
	</main>
</template>

<script>
import InfoKelulusan from "./components/InfoKelulusan.vue";
import LoginForm from "./components/LoginForm.vue";

export default {
	name: "App",
	components: {
		LoginForm,
		InfoKelulusan,
	},
	computed: {
		isAuthenticating() {
			return this.$store.getters.isAuthenticating;
		},
		isAuthenticated() {
			return this.$store.getters.isAuthenticated;
		},
		isLoading() {
			return this.$store.getters.isLoading;
		},
	},
};
</script>

<style>
#app {
	font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans", Arial, sans-serif;
}
.bg-image {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	z-index: -1;
	background-color: #dae7f1;
	background-image: url("./assets/logo.png");
	background-size: auto;
	background-position: center;
	background-attachment: local;
	background-repeat: no-repeat;
	filter: blur(5px) opacity(0.7);
}
.card {
	background-color: #f7f9ff !important;
	box-shadow: 0 0 16px 4px rgba(23, 58, 101, 0.25);
}
</style>
